<app-site-settings-menu>
    <div class="currencies-page">
        <aside class="currencies-list-panel">
            <h5 appLocalizationPopupDirective localizationCode="Currencies">
                {{ 'Currencies' | translate: {Default: "Currencies"} }}
            </h5>

            <mat-form-field class="currency-search" appearance="outline">
                <mat-label>{{ 'Search' | translate: {Default: "Search"} }}</mat-label>
                <input matInput [(ngModel)]="currencySearchValue" />
                <mat-icon class="material-icons-outlined" matPrefix>search</mat-icon>
            </mat-form-field>

            <div class="list-scroll" *ngIf="!isLoadingCurrencies; else currenciesLoader">
                <mat-nav-list class="currency-list">
                    <button
                        mat-list-item
                        type="button"
                        class="currency-list-item"
                        *ngFor="let currency of filteredCurrencies; trackBy: trackByCurrency"
                        (click)="selectCurrency(currency)"
                        [class.selected]="selectedCurrency?.id === currency.id"
                    >
                        <span matListItemTitle>{{ currency.id }}</span>
                        <!-- <span
                            matListItemLine
                            class="status"
                            [class.is-enabled]="currency.isEnabled"
                            [class.is-disabled]="!currency.isEnabled"
                        >
                            {{ currency.isEnabled ? ('Enabled' | translate: {Default: "Enabled"}) : ('Disabled' | translate: {Default: "Disabled"}) }}
                        </span> -->
                        <mat-slide-toggle
                            matListItemMeta
                            color="primary"
                            setColor="primaryColour"
                            [checked]="currency.isEnabled"
                            [disabled]="togglingCurrencyIds.has(currency.id)"
                            (click)="$event.stopPropagation()"
                            (change)="toggleCurrency(currency, $event.checked)"
                        >
                        </mat-slide-toggle>
                    </button>
                </mat-nav-list>
            </div>
        </aside>

        <section class="exchange-rates-panel">
            <ng-container *ngIf="selectedCurrency; else noCurrencySelected">
                <header class="exchange-rates-header">
                    <div>
                        <h5 appLocalizationPopupDirective localizationCode="ExchangeRates">{{ selectedCurrency.id }} {{ 'ExchangeRates' | translate: {Default: "Exchange Rates"} }}</h5>
                        <mat-chip-set>
                            <mat-chip [ngClass]="selectedCurrency.isEnabled ? 'green-chip' : 'red-chip'" selected>{{ selectedCurrency.isEnabled ? ('Enabled' | translate: {Default: "Enabled"}) : ('Disabled' | translate: {Default: "Disabled"}) }}</mat-chip>
                        </mat-chip-set>
                    </div>
                </header>

                <app-data-grid-comp
                    [tableId]="tableId"
                    [gridId]="gridId"
                    [columns]="columns"
                    [filterCategories]="filterCategories"
                    [gridDataResult]="gridDataResult"
                    [pageSize]="pageSize"
                    [skip]="skip"
                    [clearSelectedItems]="clearSelectedItems"
                    [rowSelectionSettings]="{
                        canSelectRows: true,
                        selectableMode: 'multiple',
                        selectRowBy: 'id'
                    }"
                    clickableRows="true"
                    [isLoading]="isLoadingExchangeRates"
                    showRefreshButton="true"
                    [rowActionButtons]="gridActionButtons"
                    (emitRefreshEvent)="getExchangeRates()"
                    [sort]="sort"
                    [sortable]="{
                        mode: 'multiple'
                    }"
                    [sortableColumns]="sortableColumns"
                    (emitOpenDialogEvent)="editOrCreateExchangeRate($event)"
                    (emitGridStateChangeEvent)="gridStateChange($event)"
                    (emitDeleteEvent)="openConfirmDeleteDialog($event)"
                ></app-data-grid-comp>
            </ng-container>
        </section>
    </div>

    <ng-template #currenciesLoader>
        <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    </ng-template>

    <ng-template #noCurrencySelected>
        <div class="empty-state" appLocalizationPopupDirective localizationCode="NoCurrenciesAvailable">
            {{ 'NoCurrenciesAvailable' | translate: {Default: "No currencies available."} }}
        </div>
    </ng-template>

</app-site-settings-menu>
